// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function Spinner(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  return React.createElement("div", {
              className: "w-8 h-8 animate-spin",
              style: {
                color: match.themeObj.colorTextSecondary
              }
            }, React.createElement(Icon$OrcaPaymentPage.make, {
                  name: "loader",
                  size: 32
                }));
}

var make = Spinner;

export {
  make ,
}
/* react Not a pure module */
